import {
    shouldEncryptRequestBody,
    buildEncryptedFormData,
    canEncryptParams,
} from './requestCrypto';

function buildPlainFormData(values) {
    const formData = new FormData();
    for (const key in values) {
        if (Object.prototype.hasOwnProperty.call(values, key)) {
            formData.append(`${key}`, `${values[key]}`);
        }
    }
    return formData;
}

/**
 * 构建 POST 表单；开启 REACT_APP_REQUEST_ENCRYPT 时对参数 JSON 后 AES 加密再提交。
 */
const form_data = (values) => {
    if (shouldEncryptRequestBody() && canEncryptParams(values)) {
        return buildEncryptedFormData(values);
    }
    return buildPlainFormData(values);
};

export default form_data;
